import { Component, OnInit } from '@angular/core';
import { OrderWrapperComponent } from "../../component/wrapper/order-wrapper.component";
import { Store } from '@ngrx/store';
import { OrderItem, OrderPublic } from '../../../../globalTypes/order.types';
import { takeUntil } from 'rxjs';
import { ordersFeature } from '../../store/order.store';
import { OrderService } from '../../services/order.service';
import { Base } from '../../component/wrapper/base-wrapper.component';
import { Logger } from '../../helper/logger';
import { accountFeature } from '../../store/account.store';
import { LocationPublic } from '../../../../globalTypes/account.types';
import { removeItemFromCart, RemoveItemFromCartVariables } from '@dataconnect/account';
import { UpdateItemQuantityInCartOnCallVariables } from '../../../../globalTypes/onCall.types';
import { CartComponent } from "./cart.component";
const log = new Logger("CartPageComponent");

@Component({
  selector: 'msh-cart-page',
  imports: [OrderWrapperComponent, CartComponent],
  template: `
<msh-order-wrapper
  [isCart]="true"
  [order]="order"
>
  <msh-cart></msh-cart>
</msh-order-wrapper>
  `,
  styles: ``
})
export class CartPageComponent extends Base<CartPageComponent> implements OnInit {
  locationId = '';
  locations: {[locationId: string]: LocationPublic} = {}; 
  locationIdsWithItems: string[] = []
  order?: OrderPublic

  constructor(
    private orderService: OrderService,
    private store: Store,
  ){
    super();

    this.store.select(accountFeature.selectLocations).pipe(takeUntil(this.$destroy)).subscribe(locations => {
      this.locations = locations as {[locationId:string]: LocationPublic}
    })
    this.store.select(ordersFeature.selectCart).pipe(takeUntil(this.$destroy)).subscribe(cart => {
      log.log({cart})
      if(!cart) return;
      if(Object.keys(cart.orderItems_on_order || []).length === 0){
        this.order = undefined
        return;
      }
      this.order = cart as OrderPublic

    log.log({"items on order": Object.keys(this.order.orderItems_on_order).length})
      if(this.order && this.order.orderItems_by_location){
        this.locationIdsWithItems = Object.keys(this.order.orderItems_by_location)
      }

    })
  }

  async ngOnInit(): Promise<void> {
    this.store.select(accountFeature.selectLocation).pipe(takeUntil(this.$destroy)).subscribe(location => {
      if(!location) return;
      this.locationId = location.id;
    });
  }

  async onQuantityChange(ev: any, item: OrderItem){
    const itemQuantityVars: UpdateItemQuantityInCartOnCallVariables = {
      orderItemId: item.id,
      orderId: item.orderId,
      quantity: ev,
      locationId: this.locationId,
    }
    this.orderService.updateItemQuantityAndHydrate(itemQuantityVars);
  }

  async removeItem(item: OrderItem){
    log.log({remove: item})
    const removeItemVars: RemoveItemFromCartVariables = {
      orderItemId: item.id,
      orderId: item.orderId,
      locationId: this.locationId,
    }
    try {
      const resultRef = await removeItemFromCart(removeItemVars);
      if(resultRef){
        log.log({resultRef});
        await this.orderService.hydrateCart(item.orderId, this.locationId);
      }
    } catch(error){
      log.error({error})
      // FIXME error handling
    }
  }
}
